import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Sector from './Sector';
import { divide } from '../../../../../models/market-map/divider';
import { Spinner } from "@blueprintjs/core";
import Footer from './Footer';
import Popup from './Popup';
import './index.css';


class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      marketMap:null,
      industrie:null,
      ticker:null,
      sectors: []
    }
    this.setMarketMapRatio = this.setMarketMapRatio.bind(this);
    this.divideSectors = this.divideSectors.bind(this);
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.renderSetors = this.renderSetors.bind(this);
    this.mapSetors = this.mapSetors.bind(this);
  }

  UNSAFE_componentWillReceiveProps(newProps){
    if( (newProps.dataSource.updatedAt !== this.props.dataSource.updatedAt) || 
    (newProps.showPrice !==this.props.showPrice) || (newProps.showNA !==this.props.showNA) || 
    (newProps.searchResult !==this.props.searchResult)){
      const { dataSource } = newProps;
      this.renderSetors(dataSource, newProps.showPrice, newProps.showNA, newProps.searchResult)
    }
  }

  componentDidMount(){
    this.renderSetors(this.props.dataSource, this.props.showPrice, this.props.showNA, this.props.searchResult);
    this.refs.market_map.addEventListener('DOMMouseScroll', (e) => { this.wheel(e) }, { passive: false });
    this.refs.market_map.addEventListener('mousewheel', (e) => { this.wheel(e) }, { passive: false });
    this.refs.market_map.addEventListener('wheel', (e) => { this.wheel(e) }, { passive: false });
    window.addEventListener('resize', this.setMarketMapRatio);
  }
  
  componentWillUnmount(){
    this.refs.market_map.removeEventListener('DOMMouseScroll', (e) => { this.wheel(e) }, { passive: false });
    this.refs.market_map.removeEventListener('mousewheel', (e) => { this.wheel(e) }, { passive: false });
    this.refs.market_map.removeEventListener('wheel', (e) => { this.wheel(e) }, { passive: false });
    window.removeEventListener('resize', this.setMarketMapRatio)
  }

  setMarketMapRatio(){
    this.renderSetors(this.props.dataSource, this.props.showPrice, this.props.showNA, this.props.searchResult);
  }

  divideSectors(dataSource){
    let marketMap = ReactDOM.findDOMNode(this.refs.market_map).getBoundingClientRect();
    let res = dataSource.data ? divide(dataSource.data,marketMap.width+13,marketMap.height-8,0,0) : [] //(data-array, width, height, left, top);
    return res ;
  }

  mapSetors(sectors, showPrice, showNA, searchResult){
    let res = sectors.map((sector, index)=>{ return (<Sector key={index + sector.title + sector.scale} showPrice={showPrice} showNA={showNA}
      sector={sector} onMouseHover={this.handleMouseHover} searchResult={searchResult}/>)})
    return res;
  }

  renderSetors(dataSource, showPrice, showNA, searchResult){
    let marketMap = ReactDOM.findDOMNode(this.refs.market_map).getBoundingClientRect();
    let res = this.divideSectors(dataSource);
    let sectors = this.mapSetors(res, showPrice, showNA, searchResult)
    this.setState({sectors, marketMap})
  }

  handleMouseHover(industrie, ticker){
    this.setState({industrie, ticker})
  }


  wheel(e){
    //e.preventDefault();
    //console.log('wheel e---', e)
    //   this.el.style.transition = 'all .32s';
    //   if (e.wheelDelta >= 120 || e.detail <= -3) {
    //       D.scale.up();
    //   } else {
    //       D.scale.down();
    //   }
    //   emitter2.emit('scale', D.scale.value, 160);
    //   if (D.scale.value > 1) {
    //       lastX = e.pageX - D.offset.x - ox
    //       lastY = e.pageY - D.offset.y - oy
    //       D.delta.x = -ox * (D.scale.value) + ox + lastX
    //       D.delta.y = -oy * (D.scale.value) + oy + lastY
    //       D.origin.x = D.delta.x
    //       D.origin.y = D.delta.y
    //       this.el.style.transform = `matrix(${D.scale.value}, 0, 0, ${D.scale.value}, ${D.delta.x}, ${D.delta.y})`;
    //   } else {
    //       lastX = 0
    //       lastY = 0
    //       this.reset();
    //   }
  }



  render() {
    const { sectors, marketMap, industrie, ticker } = this.state;
    const { dataSource } = this.props;
    //console.log('Map searchResult --------- ', this.props.searchResult)
    return (
      <div className='sc-market-map-container' id='sc-market-map'>
        <div className='sc-market-map-wrapper' ref="market_map">{sectors}</div>
        {dataSource.data && <Footer dataSource={dataSource}/>}
        {industrie ? <Popup industrie={industrie} ticker={ticker} marketMap={marketMap}/> : ''}
        {sectors.length === 0  && <div className='sc-market-map-spinner'>
            <Spinner className='sc-market-map-indicator' intent={"primary"} size={60} value={null} />
          </div>
        }
      </div>
    );
  }
}


export default Map;




